export default function decodeShopifyProductId(id: string) {
  const decoded = atob(id)
  const shopifyId = decoded.split("/").pop()

  return parseInt(shopifyId)
}
